import { useState } from "react";
import {
  Box,
  Button,
  Card,
  Container,
  IconButton,
  Stack,
  Typography,
  Chip,
  Grid,
  CircularProgress,
} from "@mui/material";
import Navbar from "../components/Navbar";
import Sidebar from "./Sidebar";
import Footer from "../components/Footer";
import { isMobile } from "../global/helpers";
import { useThemeColors } from "../Context/Theme";
import MyEventsAllEventsView from "./components/MyEventsAllEventsView";
import { CREATE_INTERESTED, READ_ALL_INTERESTED } from "../Api/apiConstant";
import {
  useGetAPIQuery,
  usePostAPIMutation,
  usePostAPIWithTokenMutation,
} from "../Api/api";
import { READ_ALL_EVENTS } from "../Api/apiConstant";
import MyEventsSavedEventsView from "./components/MyEventsSavedEventsView";
import { getToken, getUserId } from "../LoginModule/LoginUtility";
const MyEvents = () => {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    linkColor,
    backgroundColor,
    logo,
  } = useThemeColors();

  const events = Array(4).fill({
    title: "Soccer sport event",
    date: "September 16, 2024",
    time: "11:54 PM",
    location: "39 Anne Rd, Melbourne, Victoria",
  });

  const token = getToken();
  const userId = getUserId()

  const [activeTab, setActiveTab] = useState("all");

  const { data, isLoading, isError, error, refetch } = useGetAPIQuery({
    url: `${READ_ALL_EVENTS}`,
    token: token,
  });

  const { data: interestedData } = useGetAPIQuery({
    url: READ_ALL_INTERESTED,
    token: token,
  });

  const filteredEvents = data?.data?.filter((event) => {
    return  Array.isArray(interestedData?.data) ? interestedData?.data?.some(
      (interest) => interest.event_id !== event.event_id
    ) : false;
  });

  

  const savedEvents = data?.data?.filter((event) => {
    return Array.isArray(interestedData?.data) && interestedData?.data?.length > 0
      ? interestedData.data.some(
          (interest) => interest.event_id === event.event_id
        )
      : false;
  });

  const [createInterested, { isLoading: isCreateInterestedLoading }] =
    usePostAPIWithTokenMutation();

  const handleCreateInterested = async (eventId) => {
    try {
      createInterested({
        url: CREATE_INTERESTED,
        formData: {
          user_id: userId,
          event_id: eventId,
        },
      });

      refetch();
    } catch (error) {
      
    }
  };

  return (
    <div
      className="overflow-hidden"
      style={{ backgroundColor: backgroundColor }}
    >
      <Navbar className="sticky-navbar" />
      <Grid
        container
        spacing={4}
        style={{ margin: isMobile() ? "2% 0" : "2% 4%", marginTop: "18vh" }}
      >
        {isMobile() ? (
          <Sidebar />
        ) : (
          <Grid item xs={12} sm={10} md={2} className="">
            <Sidebar />
          </Grid>
        )}
        <Grid item xs={12} sm={10} md={9}>
          <Card
            elevation={0}
            style={{
              minHeight: "70vh",
              borderRadius: "21px",
              boxShadow:
                "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
            }}
          >
            <Container
              maxWidth="lg"
              sx={{ py: 4, height: "100%", minHeight: "70vh" }}
            >
              <Stack direction="row" height={"100%"} spacing={2} mb={4}>
                <Button
                  disableElevation
                  size="large"
                  variant={activeTab === "all" ? "contained" : "outlined"}
                  onClick={() => setActiveTab("all")}
                  sx={{
                    borderRadius: "10px",
                    borderColor: "#1a1a1a",
                    bgcolor: activeTab === "all" ? "#1a1a1a" : "transparent",
                    color: activeTab === "all" ? "white" : "#1a1a1a",
                    "&:hover": {
                      bgcolor: activeTab === "all" ? "#333" : "transparent",
                    },
                  }}
                >
                  All Event
                </Button>
                <Button
                  disableElevation
                  size="large"
                  variant={activeTab === "saved" ? "contained" : "outlined"}
                  onClick={() => setActiveTab("saved")}
                  sx={{
                    borderRadius: "10px",
                    borderColor: "#1a1a1a",
                    bgcolor: activeTab === "saved" ? "#1a1a1a" : "transparent",
                    color: activeTab === "saved" ? "white" : "#1a1a1a",
                    "&:hover": {
                      bgcolor: activeTab === "saved" ? "#333" : "transparent",
                    },
                  }}
                >
                  Saved
                </Button>
              </Stack>
              {activeTab === "all" && (
                <>
                  {isLoading ? (
                    <Stack
                      alignItems={"center"}
                      minHeight={"40vh"}
                      justifyContent={"center"}
                      width={"100%"}
                      height={"100%"}
                    >
                      <CircularProgress sx={{ color: "red" }} />
                    </Stack>
                  ) : data?.data && data?.data?.length > 0 ? (
                    <MyEventsAllEventsView
                      events={filteredEvents}
                      handleCreateInterested={handleCreateInterested}
                    />
                  ) : (
                    <Stack
                      alignItems={"center"}
                      minHeight={"40vh"}
                      justifyContent={"center"}
                      width={"100%"}
                      height={"100%"}
                    >
                      <Typography variant="h5">No events found</Typography>
                    </Stack>
                  )}
                </>
              )}
              {activeTab === "saved" && (
                <MyEventsSavedEventsView events={savedEvents} />
              )}
            </Container>
          </Card>
        </Grid>
      </Grid>
      <Footer />
    </div>
  );
};

export default MyEvents;
